import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { DropdownPopup } from '@/components/UI/DropdownPopup';

export const Menu = styled.div`
  width: 200px;
  flex-direction: column;
  padding: 10px 5px;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  border-radius: 9px;
  padding: 0 15px;
  user-select: none;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;

export const MenuItemText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))<{ $isDangerous?: boolean }>`
  color: ${({ theme, $isDangerous }) =>
    $isDangerous ? theme.palette.system.red : theme.palette.primary.labels};
`;

export const Dropdown = styled(DropdownPopup)`
  box-shadow: 10px 10px 15px 0 ${({ theme }) => theme.palette.system['ink-10']};
`;
